import { render, staticRenderFns } from "./FormulateSnippetTextarea.vue?vue&type=template&id=d57c1316"
import script from "./FormulateSnippetTextarea.vue?vue&type=script&lang=js"
export * from "./FormulateSnippetTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports